import _ from "lodash"

//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://
//                                  CLIENT SERVICE                                  //
//                                  BUSINESS LOGIC                                  //
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://
const filter = function(entry, searchValue) {
  var entryName = (entry || {}).name
  var shouldFilter = (searchValue || "").length > 0
  return shouldFilter
    ? (entryName || "").toLowerCase().indexOf(searchValue.toLowerCase()) > -1
      ? entry
      : undefined
    : entry
}

const buildClientRows = function(clientData, searchValue) {
  var clientRows = []
  var filteredData = clientData.filter(x => filter(x, searchValue))
  var tmpRow = {}
  for (let i = 0; i < filteredData.length; i++) {
    if (i % 2 == 0) {
      tmpRow.first = filteredData[i]
    } else {
      tmpRow.second = filteredData[i]
      clientRows.push(tmpRow)
      tmpRow = {}
    }
  }
  if (tmpRow.first) {
    clientRows.push(tmpRow)
  }
  return clientRows
}

const edit = function(tab, row) {
  var newTab = _.clone(tab)
  var editedIndex = _.findIndex(newTab, x => x.id === row.id)
  newTab[editedIndex] = row
  console.log(newTab)
  return newTab
}

export default {
  buildClientRows: buildClientRows,
  edit
}



// WEBPACK FOOTER //
// ./src/components/Pro/Clients/ClientService.js